import { Observable, ObservableInput, Subject, BehaviorSubject } from 'rxjs';
import { concatMap, switchMap, share } from 'rxjs/operators';

enum QueueActions {
  RESET = 'RESET',
  ADD = 'ADD'
}

interface QueueCommand {
  action: QueueActions;
  payload?: any;
}

export class ObservableCascadeQueue<T> {
  private _commands: Subject<QueueCommand> = new Subject<QueueCommand>();
  private _queues: BehaviorSubject<
    Subject<ObservableInput<T>>
  > = new BehaviorSubject<Subject<ObservableInput<T>>>(
    new Subject<ObservableInput<T>>()
  );
  queue$ = this._queues.asObservable().pipe(
    switchMap((queue: Subject<ObservableInput<T>>) =>
      queue.pipe(
        concatMap(item => item)
        // tap(e=>console.log((<any>e).option.text, (<any>e).type))
      )
    ),
    share()
  );
  constructor() {
    this._commands.asObservable().subscribe(command => {
      switch (command && command.action) {
        case QueueActions.RESET:
          this._queues.next(new Subject<ObservableInput<T>>());
          break;
        case QueueActions.ADD:
          this._queues.value.next(command.payload);
          break;
        default:
          this._queues.value.error(
            `[ObservableQueue] unknown command: ${JSON.stringify(command)}`
          );
      }
    });
    this.queue$.subscribe();
  }
  add(item: ObservableInput<T>): this {
    setTimeout(() =>
      this._commands.next({ action: QueueActions.ADD, payload: item })
    );
    return this;
  }

  reset(): this {
    this._commands.next({ action: QueueActions.RESET });
    return this;
  }
  destroy() {
    this._commands.complete();
    this._queues.value.complete();
    this._queues.complete();
  }

  asObservable(): Observable<T> {
    return this.queue$;
  }
}
